import { h } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./VersionIndicator.module.css";

interface Props {
    class?: string;
    versionIndex: number;
    activated: boolean;
}

function VersionIndicator({ class: cssClass, versionIndex, activated }: Props) {
    return (
        <div
            class={classname(
                styles.versionIndicator,
                cssClass,
                "caption-2",
                "semibold",
                {
                    [styles.activated]: activated,
                    [styles.long]: versionIndex > 99,
                    [styles.veryLong]: versionIndex > 999
                }
            )}
            title={`v${versionIndex}`}>
            v<span dir="rtl" class={classname(styles.versionIndex, "ellipsis")}>{versionIndex}</span>
        </div>
    );
}

export default VersionIndicator;
